/**
 * PC_PG_05, PC_PG_14
 * importing client 
 */
import { clientPerformance as client } from "./client";
import { PerformanceConstant } from "../constant";

/**
 * PC_TG_05,PC_TG_08
 * @param {*} templateData has the data to retrieve the data from the db
 * @returns the response
 */
export const getTemplateCategoryDetails = async (templateData = {}) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.goalTemplate,
        payload: templateData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_AF_06,PC_AF_07,PC_AF_10
 * @param {*} data - has the appreciationId to retrieve
 * @returns the particular appreciation data 
 */
export const individualAppreciation = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.individualAppreciation,
        payload: data
    }
    const response = await client(body);
    return response;
};
/**
 * PC_TG_15,PC_TG_18
 * @param {*} templateData - has the templateId to delete
 * @returns returns the successfull deletion messaage
 */
export const deleteTemplate = async (templateData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.deleteTemplate,
        payload: templateData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_TF_17,PC_TF_20
 * @param {*} updateData - has the data to update a template
 * @returns returns the success messagee after the updation
 */
export const updateTemplate = async (updateData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateTemplate,
        payload: updateData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_TF_17,PC_TF_20
 * @param {*} postData - has the data to create a new template
 * @returns returns the success messagee after the creation of new template
 */
export const postTemplate = async (postData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postTemplate,
        payload: postData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_AG_05,PC_AG_09
 * @param {*} appreciationData - has the condition to get the record
 * @returns - has the record to show in grid
 */
export const getAppreciation = async (appreciationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.appreciation,
        payload: appreciationData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_AF_16,PC_AF_21
 * @param {*} updateData - has the data to update a appreciation
 * @returns response on updating a appreciation
 */
export const updateAppreciation = async (updateData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateAppreciation,
        payload: updateData
    }
    const response = await client(body);
    return response;
};
/**
 * PC_AF_15,PC_AF_21
 * @param {*} postData - has the data to create a appreciation
 * @returns response on creating a appreciation
 */
export const postAppreciation = async (postData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postAppreciation,
        payload: postData
    }
    const response = await client(body);
    return response;
};

export const getProfileRequest = async (profileData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.profileRequest,
        payload: profileData
    }
    const response = await client(body);
    return response;
};

export const individualRequest = async (profileData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.individualProfileRequest,
        payload: profileData
    }
    const response = await client(body);
    return response;
};

export const updateRequest = async (profileData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateRequest,
        payload: profileData
    }
    const response = await client(body);
    return response;
};


/**
 * PC_PG_05
 * @param {*} policyData - policyData has employee details to retrieve the data then client function is invoked
 * @returns  returns the list of policy  to show in grid page
 */
export const getPolicy = async (policyData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.policy,
        payload: policyData
    }
    const response = await client(body);
    return response;
};
/**
 * PC_PF_07,PC_PF_10
 * @param {*} policyData has policyId to retrieve data 
 * @returns the response from the API
 */
export const getIndividualPolicy = async (policyData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.individualPolicy,
        payload: policyData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_PF_16,PC_PF_19
 * @param {*} postData has the data to post in policy 
 * @returns the response from the API
 */
export const postPolicy = async (postData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postPolicy,
        payload: postData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_PF_17,PC_PF_19
 * @param {*} policyData has the data to update a policy 
 * @returns the response from the API
 */

export const updatePolicy = async (policyData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updatePolicy,
        payload: policyData
    }
    const response = await client(body);
    return response;
};

export const policyHighlight = async () => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.totalHighlight,
        payload: {}
    }
    const response = await client(body);
    return response;
};

export const getIndividualTouchbase = async (policyData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.individualTouchbase,
        payload: policyData
    }
    const response = await client(body);
    return response;
};

export const postTouchbase = async (postData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postTouchbase,
        payload: postData
    }
    const response = await client(body);
    return response;
};

export const updateTouchbase = async (updateData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateTouchbase,
        payload: updateData
    }
    const response = await client(body);
    return response;
};

export const getTouchbase = async (touchbaseData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.touchbase,
        payload: touchbaseData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_AF_24,PC_AF_27
 * @param {*} data - has the data retrieve based on the body we passed
 * @returns - the response from the API
 */
export const directory = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.directory,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const checkFeedback = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.checkFeedback,
        payload: data
    }
    const response = await client(body);
    return response;
};


export const postFeedBack = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postTouchbaseFeedBack,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const updateFeedBack = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateTouchbaseFeedBack,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const Goal = async (data) => {
   
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.myGoal,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const postGoal = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postGoal,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const updateGoal = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateGoal,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const getIndividualGoal = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.individualGoal,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const Evaluation = async (data = {}) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.Evaluation,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const getTeamGoal = async (data) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.TeamGoal,
        payload: data
    }
    const response = await client(body);
    return response;
};

export const getGoalStatus = async () => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.goalView,
        payload: {}
    }
    const response = await client(body);
    return response;
};

export const getIndividualEvaluation = async (evaluationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.IndividualEvaluation,
        payload: evaluationData
    }
    const response = await client(body);
    return response;
};

export const getToImprove = async () => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.getToImprove,
        payload: {}
    }
    const response = await client(body);
    return response;
};
/**
 * PC_PG_15,PC_PG_18
 * @param {*} policyData -has  policy id to delete the policy
 * @returns the response from the api
 */
export const deletePolicy = async (policyData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.deletePolicy,
        payload: policyData
    }
    const response = await client(body);
    return response;
};

/**
 * PC_AG_14,PC_AG_15,PC_AG_18
 * @param {*} appreciationData - has appreciationId to delete 
 * @returns  response of deletion of appreciation
 */
export const deleteAppreciation = async (appreciationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.deleteAppreciation,
        payload: appreciationData
    }
    const response = await client(body);
    return response;
};

export const postIndividualEvaluation = async (evaluationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.postEvaluation,
        payload: evaluationData
    }
    const response = await client(body);
    return response;
};

export const updateIndividualEvaluation = async (evaluationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.updateEvaluation,
        payload: evaluationData
    }
    const response = await client(body);
    return response;
};


export const updateEvaluationStatus = async (evaluationData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.EvaluationStatus,
        payload: evaluationData
    }
    const response = await client(body);
    return response;
};

export const deleteTouchbase = async (touchbaseData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.deleteTouchbase,
        payload: touchbaseData
    }
    const response = await client(body);
    return response;
};

export const deleteGoal = async (goalData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.deleteGoal,
        payload: goalData
    }
    const response = await client(body);
    return response;
};

export const goalLimit = async (goalData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.goalLimit,
        payload: goalData
    }
    const response = await client(body);
    return response;
};


export const checkRoleEvaluation = async (goalData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.checkRoleEvaluation,
        payload: goalData
    }
    const response = await client(body);
    return response;
};

export const getIndividualLog = async (goalData) => {
    let body = {
        modulename: PerformanceConstant.modulename.performance,
        methodname: PerformanceConstant.methodname.getIndividualLog,
        payload: goalData
    }
    const response = await client(body);
    return response;
};